import React from 'react'
import styled from 'styled-components'
//import PropTypes from 'prop-types'

import MediaHeaderDaily from './Atoms/MediaHeaderDaily'
import MediaDataDaily from './Atoms/MediaDataDaily'
import MediaDataShipping from './Atoms/MediaDataShipping'

const BodyContent = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  vertical-align: middle;
  height: 520px;
`

const ContentWrap = styled.div`
  display: flex; /* 横並び */
  flex-direction: column;
  vertical-align: middle;
  width: 100%;
  height: 520px;
  padding:0.5rem;
`

export const ListUl = styled.ul`
  width: ${props => props.width ? props.width : '100%'};
  height: ${props => props.height ? props.height : '400px'};
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    border:none;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(112, 112, 112);
    border-radius: 10px;
  }
`

export const ListLi = styled.li`
  width: ${props => props.width ? props.width : 'calc(100%-18px)'};
  display: flex; /* 横並び */
  flex-direction: row;
  text-indent: 10px;
  background: ${props => props.selected ? '#048b63' : '#fff'};
  color: ${props => props.selected ? '#fff' : '#333'};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  .listId{
    margin-right:1vw;
  }
  :nth-child(even){
    background: ${props => props.selected ? '#048b63' : '#eee'};
    color: ${props => props.selected ? '#fff' : '#333'};
  }
  :hover {
    background: #ccc;
    color: #333;
  }
`
const ScreenButton = styled.button`
  display: flex;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.05em;
  text-align: center;
  vertical-align: middle;
  color: ${props => props.activeState ? '#fff' : '#000'};
  background-color: ${props => props.activeState ? '#649CDF' : '#ccc'};
  width: 80px;
  height: 30px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);
`
const TextWrap = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 
const PerformanceDaily = (props) => {
  const {
    personalList,
    onExport,
    shippingSumList,
    onClear,
    onCreate
  } = props

  return (
    <ContentWrap>
      <BodyContent>
        <div style={{width:'1537px', marginLeft:'10px', textAlign:'left'}}>
        <MediaHeaderDaily />
        <ListUl width={personalList.length >= 15 ? '1337px' : '1320px'} height={'673px'}>
        {personalList.map((item, index) => (
          <ListLi key={item.id + '_' + index} style={{ cursor: 'default' }}>
            <MediaDataDaily data={item} handleFileSelect={()=>{}}/>
          </ListLi>
        ))}
        <div style={{display:'flex',flexDirection:'column'}}>
        <div></div>
        <div style={{marginTop: '12px',marginBottom:'96px',marginLeft: 'auto',marginRight:'36px'}}>
        <ScreenButton 
            name='作成' padding='0px' type="button"  
            onClick={onExport} 
            activeState
          >
          <TextWrap style={{textAlign:'center'}}>
            <div>作成</div>
          </TextWrap>
          </ScreenButton>
        </div>
        </div>
        <MediaHeaderDaily />
        {shippingSumList.map((item, index) => (
          <ListLi key={item.id + '_' + index} style={{ cursor: 'default' }}>
            <MediaDataShipping data={item} handleFileSelect={()=>{}} onClear={onClear} onCreate={onCreate}/>
          </ListLi>
        ))}
        </ListUl>
        </div>
      </BodyContent>
    </ContentWrap>
  )
}

PerformanceDaily.propTypes = {
}

export default PerformanceDaily
